import store from '../store'

function importLayouts (view) { // Lazy Loading Route
  return (resolve) => import(
    `@/views/layouts/${view}.vue`
  ).then(resolve)
}

function importPages ({ subFolder = null, view }) {
  if (subFolder) {
    return (resolve) => import(
      `@/views/${subFolder}/${view}.vue`
    ).then(resolve)
  }

  return (resolve) => import(
    `@/views/${view}.vue`
  ).then(resolve)
}

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.authorized) {
    next()
    return
  }

  next('/')
}

/* Main layouts */
const mainContainer = importLayouts('AppMain')
const loginContainer = importLayouts('AppLogin')

/* Main views */

const loginView = importPages({ subFolder: 'auth', view: 'Index' })
const leaveApplicationView = importPages({ subFolder: 'leave', view: 'LeaveApplication' })
const leaveDashboardView = importPages({ subFolder: 'leave', view: 'LeaveDashboard' })
const orgChartView = importPages({ subFolder: 'orgchart', view: 'Index' })
const permissionView = importPages({ view: 'NoPermission' })
// const leaveReportView = importPages({ subFolder: 'report', view: 'LeaveReport' })
const officeLocationView = importPages({ subFolder: 'setup', view: 'OfficeLocation' })
const workSessionTypeView = importPages({ subFolder: 'setup', view: 'WorkSessionType' })
const leaveOnBehalfView = importPages({ subFolder: 'leave', view: 'LeaveOnBehalf' })
const attendanceImportView = importPages({ subFolder: 'attendance', view: 'Attendance' })
const myAttendanceView = importPages({ subFolder: 'attendance', view: 'MyAttendance' })
const myPayslipView = importPages({ subFolder: 'payslip', view: 'MyPayslip' })
const myEAFormView = importPages({ subFolder: 'payslip', view: 'EaForm' })
const eLetter = importPages({ subFolder: 'eLetter', view: 'ELetter' })

// ------------------------------------------------------------------------------------------

const employeeReportView = importPages({ subFolder: 'hris/reports', view: 'EmployeeReportContainerView' })
const leaveReportView = importPages({ subFolder: 'hris/reports', view: 'LeaveReportContainerView' })
const probationReportView = importPages({ subFolder: 'hris/reports', view: 'ProbationReport' })
const userProfileView = importPages({ subFolder: 'hris/user', view: 'Profile' })
const hrisEmployeeView = importPages({ subFolder: 'hris', view: 'organization/employee/Index' })
const companyView = importPages({ subFolder: 'hris', view: 'setup/Company' })
const systemSettingView = importPages({ subFolder: 'hris', view: 'setup/SystemSetting' })
const payrollSetupView = importPages({ subFolder: 'hris', view: 'setup/Payroll' })
const jobPositionView = importPages({ subFolder: 'hris', view: 'setup/JobPosition' })
const payrollView = importPages({ subFolder: 'hris', view: 'payroll/ContainerView' })
const educationView = importPages({ subFolder: 'hris', view: 'setup/Education' })
const holidayView = importPages({ subFolder: 'hris', view: 'setup/Holiday' })
const payrollReportContainerView = importPages({ subFolder: 'hris', view: 'payroll/ReportContainerView' })
const payrollPaymentReportContainerView = importPages({ subFolder: 'hris', view: 'payroll/PaymentReportContainerView' })
const payrollGovernmentReportContainerView = importPages({ subFolder: 'hris', view: 'payroll/GovernmentReportContainerView' })
const payrollELetterContainerView = importPages({ subFolder: 'hris', view: 'payroll/ELetterContainerView' })
const departmentView = importPages({ subFolder: 'hris', view: 'setup/Department' })
const disciplineView = importPages({ subFolder: 'hris', view: 'setup/Discipline' })
const probationView = importPages({ subFolder: 'hris', view: 'probation/Probation' })
const separationView = importPages({ subFolder: 'hris', view: 'setup/Separation' })
const leaveView = importPages({ subFolder: 'hris', view: 'setup/Leave' })
const roleView = importPages({ subFolder: 'hris', view: 'setup/Role' })
const notificationView = importPages({ subFolder: 'hris', view: 'setup/Notification' })
const workSessionView = importPages({ subFolder: 'hris', view: 'setup/WorkSession' })
const myLeaveView = importPages({ subFolder: 'hris', view: 'leave/MyLeave' })
const attendanceReportView = importPages({ subFolder: 'hris/reports', view: 'AttendanceReportContainerView' })
const payrollImportView = importPages({ subFolder: 'hris', view: 'import/PayrollImport' })

export default [
  { // catch-all route
    path: '*',
    redirect: {
      path: '/profile',
    },
  },
  { // default route
    path: '/',
    redirect: {
      path: '/profile',
    },
  },
  {
    path: '/login',
    component: loginContainer,
    beforeEnter: ifNotAuthenticated, // Per-Route Guard
    children: [
      {
        path: '',
        name: 'login',
        component: loginView,
      },
    ],
  },
  {
    path: '',
    component: mainContainer,
    meta: {
      name: '',
      requiresAuth: true,
    },
    children: [
      {
        path: '/permissions/deny',
        name: 'Permission Denied',
        component: permissionView,
        meta: {
          requiresAuth: true,
        },
      },

      /* Public */
      {
        path: '/profile',
        name: 'My e-Profile',
        component: userProfileView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-payslip',
        name: 'My e-Payslip',
        component: myPayslipView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-ea',
        name: 'My EA Form',
        component: myEAFormView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/e-letter',
        name: 'My e-Letter',
        component: eLetter,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/my-attendance',
        name: 'My Attendance',
        component: myAttendanceView,
        meta: {
          requiresAuth: true,
        },
      },      
      {
        path: '/orgchart',
        name: 'Organization Chart',
        component: orgChartView,
        meta: { 
          requiresAuth: true,
        },
      },

      /* Organization */
      {
        path: '/leave-applications',
        name: 'Leave Applications Management',
        component: leaveApplicationView,
        meta: { 
          requiresAuth: true,
          permission: 'view leave approvals tab',
        },
      },
      {
        path: '/leave-dashboard',
        name: 'Leave Dashboard',
        component: leaveDashboardView,
        meta: { 
          requiresAuth: true,
          permission: 'view leave dashboard',
        },
      },

      /* Setup */   
      {
        path: '/departments',
        name: 'Department',
        component: departmentView,
        meta: { 
          requiresAuth: true,
          permission: 'view department section',
        },
      },
      {
        path: '/leave-reports',
        name: 'Leave Reports',
        component: leaveReportView,
        meta: {
          requiresAuth: true,
          permission: 'view leave reports',
        },
      },
      {
        path: '/office-locations',
        name: 'Office Locations',
        component: officeLocationView,
        meta: {
          requireAuth: true,
          permission: 'setup office location view',
        },
      },
      { 
        path: '/work-session-types',
        name: 'Work Session Types',
        component: workSessionTypeView,
        meta: {
          requiresAuth: true,
          permission: 'view work session types',  
        },
      },
      {
        path: '/attendance-reports',
        name: 'Attendance Reports',
        component: attendanceReportView,
        meta: {
          requiresAuth: true,
          permission: 'view attendance reports',  
        },
      },
      {
        path: '/payrolls',
        name: 'Payroll Transaction',
        component: payrollView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll transactions',
        },
      },
      {
        path: 'system-settings',
        name: 'System Settings',
        component: systemSettingView,
        meta: {
          requireAuth: true,
          permission: 'view system settings',
        },
      },
      {
        path: '/leave-on-behalf',
        name: 'Leave On Behalf',
        component: leaveOnBehalfView,
        meta: { 
          requiresAuth: true,
            permission: 'view leaves on behalf',
          },
      },
      {
        path: '/attendances',
        name: 'Attendance Import',
        component: attendanceImportView,
        meta: { 
          requiresAuth: true,
            permission: 'view attendance import',
          },
      },
      {
        path: '/employee-reports',
        name: 'Employee Reports',
        component: employeeReportView,
        meta: {
          requiresAuth: true,
          permission: 'view employee reports',
        },
      },
      {
        path: '/employees-hris',
        name: 'Employee Management',
        component: hrisEmployeeView,
        meta: { 
          requiresAuth: true,
          permission: 'view hris employees',
          },
      },
      {
        path: '/companies',
        name: 'Companies',
        component: companyView,
        meta: { 
          requiresAuth: true,
          permission: 'view companies',
          },
      },
      {
        path: '/payroll-setup',
        name: 'Payroll',
        component: payrollSetupView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll',
        },
      },
      {
        path: '/job-position',
        name: 'Job Position',
        component: jobPositionView,
        meta: {
          requiresAuth: true,
          permission: 'view job position',
        },
      },
      {
        path: '/education',
        name: 'Education',
        component: educationView,
        meta: {
          requiresAuth: true,
          permission: 'view education',
        },
      },
      {
        path: '/holidays',
        name: 'Holiday',
        component: holidayView,
        meta: {
          requiresAuth: true,
          permission: 'view holiday',
        },
      },
      {
        path: '/payroll-reports',
        name: 'Reports',
        component: payrollReportContainerView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll reports',
        },
      },
      {
        path: '/payroll-payment-reports',
        name: 'Payment',
        component: payrollPaymentReportContainerView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll payment reports',
        },
      },      
      {
        path: '/payroll-government-reports',
        name: 'Government',
        component: payrollGovernmentReportContainerView,
        meta: {
          requiresAuth: true,
          permission: 'view payroll government reports',
        },
      },       
      {
        path: '/payroll-e-letters',
        name: 'E-Letter',
        component: payrollELetterContainerView,
        meta: {
          requiresAuth: true,
          permission: 'generate e-letters',
        },
      }, 
      {
        path: '/disciplines',
        name: 'Disciplines',
        component: disciplineView,
        meta: { 
          requiresAuth: true,
          permission: 'view discipline setup',
          },
      },
      {
        path: '/separation-types',
        name: 'Separation',
        component: separationView,
        meta: { 
          requiresAuth: true,
          permission: 'view separation types',
        },
      },
      {
        path: '/leave-setup',
        name: 'Leaves',
        component: leaveView,
        meta: { 
          requiresAuth: true,
          permission: 'view leave setup',
        },
      },
      {
        path: '/roles',
        name: 'HRIS Roles',
        component: roleView,
        meta: { 
          requiresAuth: true,
          permission: 'view roles',
        },
      },
      {
        path: '/notification-setup',
        name: 'Notification Setup',
        component: notificationView,
        meta: { 
          requiresAuth: true,
          permission: 'view notification types',
        },
      },
      {
        path: '/work-sessions',
        name: 'Work Session Setup',
        component: workSessionView,
        meta: { 
          requiresAuth: true,
          permission: 'view work session types',
        },
      },
      {
        path: '/my-leave',
        name: 'My e-Leave',
        component: myLeaveView,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/probations',
        name: 'Probations (New Position)',
        component: probationView,
        meta: { 
          requiresAuth: true,
          permission: 'view probations',
          },
      },
      {
        path: '/probation-reports',
        name: 'Probation Reports',
        component: probationReportView,
        meta: {
          requiresAuth: true,
          permission: 'view probation reports',
        },
      },
      {
        path: '/payroll-import',
        name: 'Payroll Import',
        component: payrollImportView,
        meta: { 
          requiresAuth: true,
          permission: 'view payroll import',
        },
      },
    ],
  },
]
